import { flow } from "mobx";
import { Configuration, getDefaultRemoteVideoLayoutOptions, RemoteVideoLayoutOptions, RoomState } from "../../common";
import AbstractDataComponent from "./AbstractDataComponent";

export const VIDEO_FIXTURE_NAME_PREFIX = "fixture-";
const TIMEOUT_INTERVAL = 3000;

export interface VideoFixtureLoaderProps {
    roomName: string;
    roomState: RoomState;
}

export default class VideoFixtureLoader extends AbstractDataComponent<VideoFixtureLoaderProps> {
    private mounted = false;

    public componentDidMount = flow(function* (this: VideoFixtureLoader) {
        const { roomName, roomState } = this.props;

        this.mounted = true;

        for (let i = 1; i <= Configuration.NUM_VIDEO_FIXTURES; i++) {
            roomState.videoFixtures.push((yield import(`../../assets/video/fixtures/${i}.mp4`)).default);
            roomState.videoLayout.push(
                getDefaultRemoteVideoLayoutOptions(roomName, `${VIDEO_FIXTURE_NAME_PREFIX}${i}`)
            );
        }

        if (Configuration.SHUFFLE_RANDOM_FIXTURES) {
            window.setTimeout(this.removeRandomFixture, TIMEOUT_INTERVAL);
        }
    });

    public componentWillUnmount() {
        this.mounted = false;
    }

    private removeRandomFixture = () => {
        const { roomState } = this.props;
        const randomIdx = Math.floor(Math.random() * roomState.videoLayout.length);
        const toRemove = roomState.videoLayout[randomIdx];
        if (toRemove.userId.startsWith(VIDEO_FIXTURE_NAME_PREFIX) && !toRemove.isPinned) {
            console.log("Removing fixture", toRemove);
            roomState.videoLayout.remove(toRemove);
            window.setTimeout(this.addBackFixture, TIMEOUT_INTERVAL, toRemove);
        } else {
            window.setTimeout(this.removeRandomFixture, TIMEOUT_INTERVAL);
        }
    };

    private addBackFixture = (layout: RemoteVideoLayoutOptions) => {
        const { roomState } = this.props;
        if (this.mounted) {
            console.log("Adding back fixture", layout);
            roomState.videoLayout.push(layout);
            window.setTimeout(this.removeRandomFixture, TIMEOUT_INTERVAL);
        }
    };
}
